import React from 'react';

export const CustomRadioButton = ({
  name,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  required = false,
  primaryColor = '#006EB7',
}) => {

  return (
    <label
      className={`flex items-center transition-colors ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className="peer absolute w-4 h-4 opacity-0 cursor-pointer"
        style={{
          '--focus-ring-color': primaryColor,
        }}
        onFocus={(e) => {
          const radioDiv = e.target.nextElementSibling;
          radioDiv.style.boxShadow = `0 0 0 2px ${primaryColor}40`;
        }}
        onBlur={(e) => {
          const radioDiv = e.target.nextElementSibling;
          radioDiv.style.boxShadow = 'none';
        }}
      />

      <div
        className="w-4 h-4 border-2 rounded-full pointer-events-none transition-all duration-150"
        style={{
          backgroundColor: checked ? primaryColor : 'transparent',
          borderColor: checked ? primaryColor : '#CBCDD6',
        }}
      />
      <span className="radio-button-text ml-2">{label}</span>
    </label>
  );
};
